import {
  Outlet,
  useLocation,
  useParams,
} from "react-router";
import { When } from "react-if";

import { LoadingElementPlaceholder } from "../../../../common/Atoms/LoadingElementPlaceholder";
import { useContact } from "../../../hooks/useContact";
import { Notification } from "../../../../common/Atoms/Notification";
import { Card } from "../../../../common/Atoms/Card";

import { ClickToCallProvider } from "./V2/ClickToCall";
import { ContactHeaderV2 } from "./V2/ContactHeaderV2";

export function ContactPageRoot() {
  const { isLoading, data: contact } = useContact();
  const { contactId } = useParams();
  const { pathname } = useLocation();

  // The Activity tab lays out its own cards, the other tabs keep their card
  const onActivityTab = pathname.replace(/\/$/, ``).endsWith(`/contacts/${contactId}`);

  // Starts right under the top nav and fills the viewport on wide screens, as the invoice page does
  return (
    <ClickToCallProvider>
      <div className={ `-mt-6 flex flex-col gap-5 xl:h-[calc(100dvh-5.5rem)]` }>
        { isLoading ? <LoadingElementPlaceholder /> : <ContactHeaderV2 /> }

        <When condition={ contact?.smsOptOut }>
          <Notification
            type={ `warning` }
            title={ `SMS Disabled` }
          >
            { `This contact has opted out of SMS communications, to re-enable ask them to grant permission on their Paidnice portal page.` }
          </Notification>
        </When>

        <div className={ `xl:min-h-0 xl:flex-1 xl:overflow-auto` }>
          { isLoading ? (
            <LoadingElementPlaceholder rows={ 10 } />
          ) : onActivityTab ? (
            <Outlet />
          ) : (
            <Card>
              <Outlet />
            </Card>
          ) }
        </div>
      </div>
    </ClickToCallProvider>
  );
}
